import { render, staticRenderFns } from "./CardCafeBadilico.vue?vue&type=template&id=d821c8b4&"
import script from "./CardCafeBadilico.vue?vue&type=script&lang=js&"
export * from "./CardCafeBadilico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports